"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["datas", "type", "valid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var redux_form_1 = require("redux-form");

var replaceTestParams_1 = __importDefault(require("../../../utils/replaceTestParams"));

var verifyCondition_1 = __importDefault(require("../../../utils/verifyCondition"));

var WithChildren_1 = __importDefault(require("../WithChildren"));

var DataCondition = function DataCondition(_ref) {
  var datas = _ref.datas,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'box' : _ref$type,
      valid = _ref.valid,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!valid) {
    return null;
  }

  return react_1.default.createElement(WithChildren_1.default, _objectSpread(_objectSpread({}, props), {}, {
    componentType: type,
    datas: datas
  }));
};

exports.default = (0, react_redux_1.connect)(function (state, props) {
  if (!props.formName) {
    throw new Error('the formName props est obligatoire');
  }

  var formValues = (0, redux_form_1.getFormValues)(props.formName)(state);
  var params = props.params,
      test = props.test;
  var newTest = params ? (0, replaceTestParams_1.default)(test, params) : test;
  var valid = (0, verifyCondition_1.default)({
    formValues: formValues,
    test: newTest
  });
  return {
    valid: valid
  };
})(DataCondition);